export default __webpack_public_path__ + "static/media/arrow-top-left.f06548fc.svg";